<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :disabled="blocked"
        v-bind="attrs"
        v-on="on"
        dense
        :color="color"
        class="m-2"
        @click="$emit('onclick')"
      >
        {{ icon }}
      </v-icon>
    </template>
    <span> {{ message }} </span>
  </v-tooltip>
</template>
<script>
export default {
  props: {
    icon: String,
    message: String,
    color: String,
    blocked: Boolean,
  },
};
</script>
